var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNotification = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#B2B2B2",
  fillRule: "evenodd",
  stroke: "#B2B2B2",
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.274 19.864a2.355 2.355 0 0 1-2.249 1.673 2.354 2.354 0 0 1-2.244-1.673H9.27a2.85 2.85 0 0 0 2.756 2.16 2.848 2.848 0 0 0 2.756-2.16h-.507z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.264 19.371h-5.888v.005H9.674v-.005H3.786a1.263 1.263 0 0 1-1.273-1.278c0-.712.56-1.273 1.273-1.273.888 0 1.654-.668 1.78-1.551l.85-6.137a5.708 5.708 0 0 1 3.945-4.634l.171-.054v-.438c0-.825.674-1.493 1.493-1.493.82 0 1.493.668 1.493 1.493v.438l.17.054a5.709 5.709 0 0 1 3.947 4.634l.848 6.137a1.813 1.813 0 0 0 1.78 1.55c.713 0 1.274.562 1.274 1.274 0 .717-.56 1.278-1.273 1.278m0-3.039a1.322 1.322 0 0 1-1.298-1.132l-.843-6.136c-.323-2.288-1.932-4.22-4.118-4.975v-.083c0-1.093-.887-1.98-1.98-1.98s-1.98.887-1.98 1.98v.083c-2.186.755-3.796 2.687-4.118 4.975L5.084 15.2a1.322 1.322 0 0 1-1.298 1.132c-.986 0-1.761.776-1.761 1.761 0 .99.775 1.766 1.76 1.766H9.27v.005h5.512v-.005h5.483c.985 0 1.76-.775 1.76-1.766 0-.985-.775-1.76-1.76-1.76"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgNotification);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/notification.4053be8be8a7ce1dcda9888332e88c34.svg";